export default "__VITE_ASSET__CLnsDuCn__"